import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IRootProps {
  isError?: boolean;
}

export const Root = styled.div`
  z-index: 10100;
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  justify-content: center;
  align-items: center;
  -webkit-backdrop-filter: blur(20px);
  backdrop-filter: blur(20px);
  background-color: rgba(0, 0, 0, 0.46);
`

export const WarningBox = styled.div`
  position: relative;
  width: calc(592px - 31px - 31px);
  min-height: calc(391px - 86px);
  padding: 0px 0px 86px 0px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  border-radius: 6px;
  border:  ${(props: IRootProps) => props.isError ? `1px solid ${C.DARK_ORANGE}` : ''};
`

export const Title = styled.div`
  height: 82px;
  padding: 0px 31px 0px 31px;
  font-family: Roboto;
  font-size: 24px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #272727;
  background-color: #e0e0e0;
  display: flex;
  align-items: center;
`

export const Content = styled.div`
  min-height: 223px;
  display: flex;
  flex-direction: column;
  align-content: space-between;
  -webkit-align-content: space-between;
  float: left;
  -ms-box-orient: horizontal;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -moz-flex;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-flow: row wrap;
  flex-flow: row wrap;
`

export const Subtitle = styled.div`
  padding: 23px 31px 0px 31px;
  flex-grow: 0;
  font-family: Roboto;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
  white-space: pre-wrap;
`

export const ActionsContainer = styled.div`
  position: absolute;
  display: flex;
  right: 31px;
  bottom: 31px;
`

export const ErrorContainer = styled.div`
  max-height: 150px;
  overflow-y: auto;
  margin: 23px 31px 0px 31px;
  width: calc(100% - 62px);
`

export const ErrorNotes = styled.div`
  background-image: linear-gradient(to top, #f36868, #f66000);
  font-family: Roboto;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  margin: 0px 0px 17px 0px;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  display: flex;
`

export const ErrorArguments = styled.div`
  margin-top: 5px;
  background-image: linear-gradient(to top, #f36868, #f66000);
  font-family: Roboto;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
`

export const Error = styled.div`
  font-weight: bold;
  margin-right: 6px;
`

export const Action = styled.div`
  min-width: 112px;
`